import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-25v1',
  templateUrl: './25v1.component.html',
  styleUrls: ['./25v1.component.scss'],
})
export class VbGeneral25v1Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
